import { TypeMetricUnit } from '@trace/types';
import humanizeFileSize from 'filesize';
import round from 'lodash.round';
import humanizeNumber from 'numbro';
import prettyMs from 'pretty-ms';

const humanizeFileSizeBR = humanizeFileSize.partial({
  spacer: '',
  round: 0,
});

export const formatter1 = (value: number, precision = 3): string =>
  humanizeNumber(value).format({
    average: true,
    totalLength: precision,
    trimMantissa: true,
  });

export const formatterBytes = (value: number): string => humanizeFileSizeBR(value);

export const formatterMs = (value: number): string =>
  prettyMs(value, {
    unitCount: 2,
    secondsDecimalDigits: 1,
  });

export const formatterSeconds = (value: number): string => formatterMs(value * 1000);

export const formatterNumberPerS = (value: number): string => `${formatter1(value, 1)}`;

export const formatterPercent = (value: number): string => `${round(value, 2)}%`;

const formatters: {
  [key in TypeMetricUnit]: (value: number) => string;
} = {
  1: formatter1,
  bytes: formatterBytes,
  ms: formatterMs,
  'number/s': formatterNumberPerS,
  percent: formatterPercent,
  seconds: formatterSeconds,
};

export default (unit: TypeMetricUnit, value?: null | number): string => {
  const formatter = formatters[unit];

  if (value === null || value === undefined || !Number.isFinite(value)) return 'N/A';
  if (formatter) return formatter(value);
  if (!Number.isNaN(value)) return formatter1(value);

  return value.toString();
};
